import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[80vh] pt-32 pb-xl flex items-center">
      <div className="max-w-[1280px] mx-auto px-6 text-center">
        <span className="font-label-caps text-on-tertiary-container bg-tertiary-fixed px-3 py-1 rounded-full inline-block mb-6">
          404 · Page not found
        </span>
        <h1 className="font-h1 text-[40px] md:text-h1 text-primary mb-4">
          That route is off the <span className="text-gradient">monitoring grid.</span>
        </h1>
        <p className="text-body-lg text-on-surface-variant max-w-xl mx-auto mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-4 bg-brand text-white font-bold rounded-xl shadow-lg hover:-translate-y-0.5 transition-all"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
}
